import React from "react";
import { Grid } from "@mui/material";

import QrCodeGeneratorNanesa from "./QrCodeGeneratorNanesa";
import { useLocation } from "react-router-dom";

interface QrCodeSectionProps {
  onQrCodeGenerated: (url: string, extractedData: any) => void;
  isTwoColumns: boolean;
  onPdfFilesChange?: (files: { coa?: File; sds?: File; ddt?: File }) => void; // Add this
}

const QrCodeSection: React.FC<QrCodeSectionProps> = ({ onQrCodeGenerated, isTwoColumns, onPdfFilesChange }) => {
  const location = useLocation();

  return (
    <Grid size={{ xs: 12, sm: isTwoColumns ? 6 : 12 }}>
      <QrCodeGeneratorNanesa onQrCodeGenerated={onQrCodeGenerated} onPdfFilesChange={onPdfFilesChange} />
    </Grid>
  );
};

export default QrCodeSection;
